export default {
  'APP_UPDT_FULFILLMENT_FACILITY': 'STOREFULFILLMENT_ADMIN',
  'APP_UPDT_PICKER_CONFG': 'STOREFULFILLMENT_ADMIN',
  'APP_USER_CREATE': 'PARTYMGR_CREATE OR PARTYMGR_ADMIN OR SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_USER_PROFILE_UPDATE': 'PARTYMGR_UPDATE OR PARTYMGR_ADMIN',
  'APP_USER_STATUS_UPDATE': 'PARTYMGR_STS_UPDATE OR PARTYMGR_UPDATE OR PARTYMGR_ADMIN',
  'APP_USER_CONTACT_CREATE': 'PARTYMGR_PCM_CREATE OR PARTYMGR_ADMIN',
  'APP_USER_CONTACT_UPDATE': 'PARTYMGR_PCM_UPDATE OR PARTYMGR_UPDATE OR PARTYMGR_ADMIN',
  'APP_USER_CONTACT_DELETE': 'PARTYMGR_PCM_DELETE OR PARTYMGR_ADMIN',
  'APP_UPDT_BLOCK_LOGIN': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_UPDT_PASSWORD': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_UPDT_PRODUCT_STORE_CONFG': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_SECURITY_GROUP_CREATE': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_SECURITY_GROUP_ASSIGNMENT': 'SECURITY_CREATE OR SECURITY_ADMIN OR PARTY_SECURITY_ASSIGNMENT',
  'APP_PERMISSION_CREATE': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_PERMISSION_UPDATE': 'SECURITY_UPDATE OR SECURITY_ADMIN',
  'APP_PERMISSION_VIEW': 'SECURITY_VIEW OR SECURITY_ADMIN',
  'APP_SUPER_USER': 'WEBTOOLS_VIEW',
  'USERS_APP_VIEW': 'USERS_APP_VIEW',
  'USERS_LIST_VIEW': 'USERS_LIST_VIEW OR PARTYMGR_VIEW OR PARTYMGR_ADMIN',
  'APP_COMMERCE_VIEW': 'COMMERCEUSER_VIEW',
  'APP_PWA_STANDALONE_ACCESS': 'COMMON_ADMIN'
} as any
